"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InteractiveStreamQuestions = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _InteractiveStreamQuestions = require("./InteractiveStreamQuestions.styled");
var _InteractiveChatMessages = require("../InteractiveChatMessages/InteractiveChatMessages.styled");
var _QuestionTabs = require("../QuestionTabs");
var _Questions = require("./components/Questions");
var _constants = require("../../../constants");
var _InteractiveChatMessages2 = require("../InteractiveChatMessages");
var _Notification = require("../../Notification");
var _DropdownMenu = _interopRequireDefault(require("../InteractiveChatMessages/components/DropdownMenu"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var InteractiveStreamQuestions = exports.InteractiveStreamQuestions = function InteractiveStreamQuestions(_ref) {
  var isAdmin = _ref.isAdmin,
    isQAEnabled = _ref.isQAEnabled,
    onToggle = _ref.onToggle,
    questions = _ref.questions,
    inputMarginBottom = _ref.inputMarginBottom,
    onInput = _ref.onInput,
    onAnswerSubmit = _ref.onAnswerSubmit,
    onArchiveClick = _ref.onArchiveClick,
    onRestoreClick = _ref.onRestoreClick,
    onLikeClick = _ref.onLikeClick,
    viewerId = _ref.viewerId,
    notificationMessage = _ref.notificationMessage,
    showNotification = _ref.showNotification,
    delay = _ref.delay,
    clearQA = _ref.clearQA;
  var _useState = (0, _react.useState)(_constants.QUESTIONS_OPEN_TYPE),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    filteredType = _useState2[0],
    setFilteredType = _useState2[1];
  var onTabChanged = function onTabChanged(tab) {
    setFilteredType(tab);
  };
  return /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.Wrapper, null, /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.TitleWrapper, null, /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.Title, null, "Q&A"), isAdmin && /*#__PURE__*/_react["default"].createElement(_DropdownMenu["default"], {
    title: "Q&A",
    onClear: clearQA,
    onToggle: onToggle,
    enabled: isQAEnabled
  })), /*#__PURE__*/_react["default"].createElement(_QuestionTabs.QuestionTabs, {
    showArchived: isAdmin,
    showDefaultText: isAdmin && !questions.length,
    onTabChanged: onTabChanged
  }), isQAEnabled ? /*#__PURE__*/_react["default"].createElement(_Questions.Questions, {
    questions: questions,
    isAdmin: isAdmin,
    filteredType: filteredType,
    onAnswerSubmit: onAnswerSubmit,
    onArchiveClick: onArchiveClick,
    onRestoreClick: onRestoreClick,
    onLikeClick: onLikeClick,
    viewerId: viewerId
  }) : /*#__PURE__*/_react["default"].createElement(_InteractiveStreamQuestions.EmptyWrapper, null, /*#__PURE__*/_react["default"].createElement(_InteractiveStreamQuestions.QuestionIcon, {
    icon: _freeSolidSvgIcons.faQuestionCircle
  })), isQAEnabled && !isAdmin && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showNotification && /*#__PURE__*/_react["default"].createElement(_InteractiveStreamQuestions.NotificationWrapper, null, /*#__PURE__*/_react["default"].createElement(_Notification.Notification, {
    message: notificationMessage,
    delay: delay
  })), /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages2.MessageInput, {
    placeholder: "Type your question...",
    onInput: onInput,
    inputMarginBottom: inputMarginBottom,
    allowAnon: true
  })));
};
InteractiveStreamQuestions.defaultProps = {
  notificationMessage: 'Question Submitted!',
  showNotification: true,
  delay: 1000
};